import { request } from ".";
import { Id } from "src/utils/types";

export type FeedbackClassification =
  | "Observação geral"
  | "Situação de risco"
  | "Sugestão de ação";

export type FeedbackAttachment = {
  value: string;
  [key: string]: any;
};

export type FeedbackEntry = {
  id: number;
  psychologist_id: number;
  company_id: number;
  company_name?: string | null;
  classification: FeedbackClassification | string;
  message: string;
  collaborator_id?: number | null;
  collaborator_name?: string | null;
  attachments: FeedbackAttachment[];
  created_at: string;
};

export type GetFeedbacksResponse = {
  feedbacks: FeedbackEntry[];
  classification_options?: FeedbackClassification[];
};

export type CreateFeedbackPayload = {
  company_id: Id;                         // 👈 aqui é o ponto chave
  classification: FeedbackClassification;
  message: string;
  collaborator_id?: Id;
  attachments?: FeedbackAttachment[];
};

export async function getFeedbacks(
  companyId?: Id
): Promise<GetFeedbacksResponse> {
  const params =
    companyId !== undefined && companyId !== "" && companyId !== "-1"
      ? { company_id: companyId }
      : {};

  const response = await request.get<GetFeedbacksResponse>("/feedbacks", {
    params,
  });

  return response.data;
}

export async function createFeedback(
  payload: CreateFeedbackPayload
): Promise<void> {
  await request.post("/feedbacks", payload);
}
